// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    .tnc_main{
        display: flex;
        justify-content: center;
        margin-top: 50px;
    }
    .tnc{
        width: 90%;
        /* display: flex; */
        /* justify-content: center; */
    }

    .tnc h2{
        font-size: 58px;
        font-weight: 700;
        color: #141414;
        font-family: 'Poppins', sans-serif !important;
    }

/* Base styles - already defined */

.tnc_mainsec {
    background: linear-gradient(to right, #9E37FF, #F237FF);
    margin-left: 15px;
    display: flex;
    justify-content: space-between;
}

.tnc_leftsec {
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding-top: 10px;
}

.tnc_leftsec h4 {
    font-size: 36px;
    font-weight: bold;
    color: #ffffff;
    font-family: 'Poppins', sans-serif !important;
}

.tnc_leftsec p {
    color: #ffffff;
    font-size: 16px;
    font-family: 'Poppins', sans-serif !important;
    font-weight: 400;
}

.tnc_btn {
    margin-right: 20px;
    margin-bottom: 10px;
    padding: 10px 20px;
    color: #ffff;
    border: none;
    letter-spacing: 1.25px;
    background: linear-gradient(to right, #7511D3 0%, #691A6F 100%);
    font-size: 10px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif !important;  
}

.tnc_rightsec img {
    width: 200px;
    height: 100%;
    margin-right: -12px;
}

/* Responsive adjustments */

@media (max-width: 1024px) {
    .tnc_leftsec h4 {
        font-size: 28px; /* Smaller font size on tablets */
    }

    .tnc_leftsec p {
        font-size: 14px;
    }

    .tnc_btn {
        font-size: 8px; /* Smaller button font size */
        padding: 8px 16px;
    }

    .tnc_rightsec img {
        width: 150px; /* Smaller image on tablets */
    }
}

@media (max-width: 768px) {
    .tnc_leftsec h4 {
        font-size: 24px; /* Smaller font size for mobiles */
    }

    .tnc_leftsec p {
        font-size: 12px;
    }

    .tnc_btn {
        font-size: 8px; /* Adjust button size for smaller screens */
    }

    .tnc_rightsec img {
        width: 120px; /* Adjust width to fit smaller screens better */
    }
}

@media (max-width: 480px) {
    .tnc_secondsec{
        display: none;
    }
    .tnc_leftsec h4 {
        font-size: 20px; /* Even smaller font size for very small devices */
    }

    .tnc_rightsec img {
        width: 100px; /* Further reduce the image size for very small screens */
    }
}


.terms-and-conditions p{
    font-size: 24px;
    font-family: 'Poppins', sans-serif !important;
    color: #848484;
    margin-top: 20px;
    margin-bottom: 20px;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/Pages/tnc.css"],"names":[],"mappings":"IAAI;QACI,aAAa;QACb,uBAAuB;QACvB,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,6CAA6C;IACjD;;AAEJ,kCAAkC;;AAElC;IACI,uDAAuD;IACvD,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,+DAA+D;IAC/D,eAAe;IACf,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA,2BAA2B;;AAE3B;IACI;QACI,eAAe,EAAE,iCAAiC;IACtD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc,EAAE,6BAA6B;QAC7C,iBAAiB;IACrB;;IAEA;QACI,YAAY,EAAE,6BAA6B;IAC/C;AACJ;;AAEA;IACI;QACI,eAAe,EAAE,kCAAkC;IACvD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc,EAAE,2CAA2C;IAC/D;;IAEA;QACI,YAAY,EAAE,+CAA+C;IACjE;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe,EAAE,kDAAkD;IACvE;;IAEA;QACI,YAAY,EAAE,yDAAyD;IAC3E;AACJ;;;AAGA;IACI,eAAe;IACf,6CAA6C;IAC7C,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":["    .tnc_main{\n        display: flex;\n        justify-content: center;\n        margin-top: 50px;\n    }\n    .tnc{\n        width: 90%;\n        /* display: flex; */\n        /* justify-content: center; */\n    }\n\n    .tnc h2{\n        font-size: 58px;\n        font-weight: 700;\n        color: #141414;\n        font-family: 'Poppins', sans-serif !important;\n    }\n\n/* Base styles - already defined */\n\n.tnc_mainsec {\n    background: linear-gradient(to right, #9E37FF, #F237FF);\n    margin-left: 15px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.tnc_leftsec {\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    padding-top: 10px;\n}\n\n.tnc_leftsec h4 {\n    font-size: 36px;\n    font-weight: bold;\n    color: #ffffff;\n    font-family: 'Poppins', sans-serif !important;\n}\n\n.tnc_leftsec p {\n    color: #ffffff;\n    font-size: 16px;\n    font-family: 'Poppins', sans-serif !important;\n    font-weight: 400;\n}\n\n.tnc_btn {\n    margin-right: 20px;\n    margin-bottom: 10px;\n    padding: 10px 20px;\n    color: #ffff;\n    border: none;\n    letter-spacing: 1.25px;\n    background: linear-gradient(to right, #7511D3 0%, #691A6F 100%);\n    font-size: 10px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif !important;  \n}\n\n.tnc_rightsec img {\n    width: 200px;\n    height: 100%;\n    margin-right: -12px;\n}\n\n/* Responsive adjustments */\n\n@media (max-width: 1024px) {\n    .tnc_leftsec h4 {\n        font-size: 28px; /* Smaller font size on tablets */\n    }\n\n    .tnc_leftsec p {\n        font-size: 14px;\n    }\n\n    .tnc_btn {\n        font-size: 8px; /* Smaller button font size */\n        padding: 8px 16px;\n    }\n\n    .tnc_rightsec img {\n        width: 150px; /* Smaller image on tablets */\n    }\n}\n\n@media (max-width: 768px) {\n    .tnc_leftsec h4 {\n        font-size: 24px; /* Smaller font size for mobiles */\n    }\n\n    .tnc_leftsec p {\n        font-size: 12px;\n    }\n\n    .tnc_btn {\n        font-size: 8px; /* Adjust button size for smaller screens */\n    }\n\n    .tnc_rightsec img {\n        width: 120px; /* Adjust width to fit smaller screens better */\n    }\n}\n\n@media (max-width: 480px) {\n    .tnc_secondsec{\n        display: none;\n    }\n    .tnc_leftsec h4 {\n        font-size: 20px; /* Even smaller font size for very small devices */\n    }\n\n    .tnc_rightsec img {\n        width: 100px; /* Further reduce the image size for very small screens */\n    }\n}\n\n\n.terms-and-conditions p{\n    font-size: 24px;\n    font-family: 'Poppins', sans-serif !important;\n    color: #848484;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
